import { styled } from '@mui/material/styles';
import { CenterContent } from 'global/components/perform-grid';

export const ChangelogContent = styled(CenterContent)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(8),
  overflowWrap: 'anywhere',
  [theme.breakpoints.up('md')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: theme.breakpoints.values.md,
  },
}));

export const ChangelogActive = styled('span')({
  fontWeight: 'bold',
});
